export const showConfirm = {
	methods: {
		mixinShowConfirm({
			text,
			title,
			acceptText,
			cancelText,
		} = {}) {
			return new Promise(resolve => {
				this.$vs.dialog({
					type: "confirm",
					color: "danger",
					title: title ||  this.$t("Actions.Confirm"),
					text: text || this.$t("Notify.DeleteConfirm"),
					acceptText: acceptText || this.$t("Actions.Agree"),
					cancelText: cancelText || this.$t("Actions.Cancel"),
					accept: () => resolve(true),
					cancel: () => resolve(false)
				});
			});
		}
	}
};
